import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer";
import Navbar from "../../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiGet, apiPost } from "../../../API/Api_Url";
import { FaTimes } from "react-icons/fa";

function UserAddMaterialRequest() {
  const navigate = useNavigate();
  const [IsUploading, setIsUploading] = useState(false);
  const [Requirements, setRequirements] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [errors, setErrors] = useState({});

  const [UserRequirement, setUserRequirement] = useState("");
  const [Address, setAddress] = useState("");
  const [City, setCity] = useState("");
  const [State, setState] = useState("");
  const [deliveryDate, setdeliveryDate] = useState("");
  const [note, setNote] = useState("");

  const [materialItems, setMaterialItems] = useState([
    { materialName: "", quantity: "", unit: "", specifications: "", brandPreference: "" }
  ]);

  const GetUserAllInRequirements = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet("api/user/GetAllUserInConstructionConstructionRequirement");
      setRequirements(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsUploading(false);
    }
  };

  useEffect(() => {
    GetUserAllInRequirements();
  }, []);

  const handleRemoveMaterial = (index) => {
    const updated = materialItems.filter((_, idx) => idx !== index);
    setMaterialItems(updated);
  };

  const validateForm = () => {
    let newErrors = {};

    if (!UserRequirement.trim()) newErrors.UserRequirement = "Requirement is required";
    if (!Address.trim()) newErrors.Address = "Address is required";
    if (!City.trim()) newErrors.City = "City is required";
    if (!State.trim()) newErrors.State = "State is required";
    if (!deliveryDate.trim()) newErrors.deliveryDate = "Delivery date is required";

    let materialErrors = [];
    materialItems.forEach((item, idx) => {
      let itemErr = {};
      if (!item.materialName.trim()) itemErr.materialName = "Material name is required";
      if (!item.quantity) itemErr.quantity = "Quantity is required";
      if (!item.unit.trim()) itemErr.unit = "Unit is required";
      if (Object.keys(itemErr).length > 0) {
        materialErrors[idx] = itemErr;
      }
    });

    if (materialErrors.length > 0) {
      newErrors.MaterialItems = materialErrors;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUploadRequirement = async () => {
    if (!validateForm()) return;

    const payload = {
      UserRequirement,
      MaterialItems: materialItems.map((item) => ({
        materialName: item.materialName,
        quantity: Number(item.quantity),
        unit: item.unit,
        specifications: item.specifications,
        brandPreference: item.brandPreference,
      })),
      deliveryDate,
      location: { Address, City, State },
      note,
    };

    try {
      setIsLoading(true);
      const response = await apiPost("/api/user/UserCreateMaterialRequest", payload);
      if (response?.data) {
        toast.success(
          response?.data?.message ||
          response?.message ||
          "Material request created successfully!"
        );
        setUserRequirement("");
        setAddress("");
        setCity("");
        setState("");
        setdeliveryDate("");
        setNote("");
        setMaterialItems([{ materialName: "", quantity: "", unit: "", specifications: "", brandPreference: "" }]);
        setShowConfirmation(true);

        setTimeout(() => {
          setShowConfirmation(false);
          navigate("/");
        }, 3000);
      } else {
        toast.error(response?.message || "Failed to create material request");
      }
    } catch (error) {
      console.error("Error uploading requirement:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const selectRequirement = (id) => {
    const selectedReq = Requirements.find((req) => req._id === id);
    if (selectedReq) {
      setUserRequirement(selectedReq._id);
      setAddress(selectedReq?.Location?.Address || "");
      setCity(selectedReq?.City || "");
      setState(selectedReq?.State || "");
    }
  };

  return (
    <>
      <Navbar />
      <div className="w-full mx-auto pt-[10%]">
        {showConfirmation ? (
          <div className="pt-[3%] pb-[5%]">
            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
              <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50 text-center p-6">
                <h2 className="text-4xl font-bold text-green-600 mb-4">
                  🎉 Your material request is live!
                </h2>
                <p className="text-2xl text-gray-800">
                  Suppliers will connect with you soon.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="pt-[3%] pb-[5%]">
            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                Add Material Request
              </h2>

              <div className="grid grid-cols-1 gap-5 pt-5">
                <div>
                  <label className="block mb-1 font-medium">
                    Select Requirement<span className="text-red-500">*</span>
                  </label>
                  <select
                    className={`form-input w-full ${errors?.UserRequirement ? "border-red-500" : ""}`}
                    value={UserRequirement}
                    onChange={(e) => selectRequirement(e.target.value)}
                  >
                    <option value="">Select Requirement</option>
                    {Requirements?.map((req) => (
                      <option key={req?._id} value={req?._id}>
                        {req?.ProjectType} ({req?.SizeDimension?.Area})
                      </option>
                    ))}
                  </select>
                  {errors?.UserRequirement && (
                    <p className="text-red-500 text-sm mt-1">{errors?.UserRequirement}</p>
                  )}
                </div>
              </div>

              <div className="mt-6">
                <label className="block mb-1 font-medium">
                  Material Items<span className="text-red-500">*</span>
                </label>
                {materialItems?.map((item, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-5 gap-3 mb-3 items-start">
                    <div>
                      <input
                        type="text"
                        placeholder="Material Name"
                        className={`form-input ${errors?.MaterialItems?.[index]?.materialName ? "border-red-500" : ""}`}
                        value={item?.materialName}
                        onChange={(e) => {
                          const updated = [...materialItems];
                          updated[index].materialName = e.target.value;
                          setMaterialItems(updated);
                        }}
                      />
                      {errors?.MaterialItems?.[index]?.materialName && (
                        <p className="text-red-500 text-sm">{errors?.MaterialItems[index]?.materialName}</p>
                      )}
                    </div>

                    <div>
                      <input
                        type="number"
                        placeholder="Quantity"
                        className={`form-input ${errors?.MaterialItems?.[index]?.quantity ? "border-red-500" : ""}`}
                        value={item.quantity}
                        onChange={(e) => {
                          const updated = [...materialItems];
                          updated[index].quantity = e.target.value;
                          setMaterialItems(updated);
                        }}
                      />
                      {errors?.MaterialItems?.[index]?.quantity && (
                        <p className="text-red-500 text-sm">{errors.MaterialItems[index].quantity}</p>
                      )}
                    </div>

                    <div>
                      <select
                        className={`form-input w-full ${errors?.MaterialItems?.[index]?.unit ? "border-red-500" : ""}`}
                        value={item.unit}
                        onChange={(e) => {
                          const updated = [...materialItems];
                          updated[index].unit = e.target.value;
                          setMaterialItems(updated);
                        }}
                      >
                        <option value="">Select Unit</option>
                        <option value="Kg">Kg</option>
                        <option value="Litre">Litre</option>
                        <option value="Meter">Meter</option>
                        <option value="Feet">Feet</option>
                        <option value="Inch">Inch</option>
                        <option value="Square Feet">Square Feet</option>
                        <option value="Square Meter">Square Meter</option>
                        <option value="Piece">Piece</option>
                        <option value="Bag">Bag</option>
                        <option value="Box">Box</option>
                      </select>
                      {errors?.MaterialItems?.[index]?.unit && (
                        <p className="text-red-500 text-sm">{errors.MaterialItems[index].unit}</p>
                      )}
                    </div>
                    <input
                      type="text"
                      placeholder="Specifications"
                      className="form-input"
                      value={item.specifications}
                      onChange={(e) => {
                        const updated = [...materialItems];
                        updated[index].specifications = e.target.value;
                        setMaterialItems(updated);
                      }}
                    />

                    <div className="flex items-center">
                      <input
                        type="text"
                        placeholder="Brand Preference"
                        className="form-input"
                        value={item.brandPreference}
                        onChange={(e) => {
                          const updated = [...materialItems];
                          updated[index].brandPreference = e.target.value;
                          setMaterialItems(updated);
                        }}
                      />
                      {materialItems.length > 1 && (
                        <button
                          type="button"
                          className="ml-2 text-red-500 hover:text-red-700"
                          onClick={() => handleRemoveMaterial(index)}
                        >
                          <FaTimes />
                        </button>
                      )}
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  className="mt-2 px-3 py-1 bg-blue-500 text-white text-sm rounded-lg hover:bg-blue-600"
                  onClick={() =>
                    setMaterialItems([
                      ...materialItems,
                      { materialName: "", quantity: "", unit: "", specifications: "", brandPreference: "" }
                    ])
                  }
                >
                  + Add More Material
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5">
                <div>
                  <label className="block mb-1 font-medium">
                    Address<span className="text-red-500">*</span>
                  </label>
                  <input
                    className={`form-input w-full ${errors?.Address ? "border-red-500" : ""}`}
                    type="text"
                    placeholder="Enter Address"
                    value={Address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  {errors?.Address && <p className="text-red-500 text-sm mt-1">{errors?.Address}</p>}
                </div>

                <div>
                  <label className="block mb-1 font-medium">
                    City<span className="text-red-500">*</span>
                  </label>
                  <input
                    className={`form-input w-full ${errors?.City ? "border-red-500" : ""}`}
                    type="text"
                    placeholder="Enter City"
                    value={City}
                    onChange={(e) => setCity(e.target.value)}
                  />
                  {errors?.City && <p className="text-red-500 text-sm mt-1">{errors?.City}</p>}
                </div>

                <div>
                  <label className="block mb-1 font-medium">
                    State<span className="text-red-500">*</span>
                  </label>
                  <input
                    className={`form-input w-full ${errors?.State ? "border-red-500" : ""}`}
                    type="text"
                    placeholder="Enter State"
                    value={State}
                    onChange={(e) => setState(e.target.value)}
                  />
                  {errors?.State && <p className="text-red-500 text-sm mt-1">{errors?.State}</p>}
                </div>

                <div>
                  <label className="block mb-1 font-medium">
                    Delivery Date<span className="text-red-500">*</span>
                  </label>
                  <input
                    className={`form-input w-full ${errors?.deliveryDate ? "border-red-500" : ""}`}
                    type="date"
                    value={deliveryDate}
                    onChange={(e) => setdeliveryDate(e.target.value)}
                  />
                  {errors?.deliveryDate && (
                    <p className="text-red-500 text-sm mt-1">{errors?.deliveryDate}</p>
                  )}
                </div>
              </div>

              <div className="mt-6">
                <label className="block mb-1 font-medium">Note (Optional)</label>
                <textarea
                  className="form-input w-full"
                  placeholder="Add any special instructions"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>

              <button
                onClick={handleUploadRequirement}
                disabled={IsLoading}
                className={`w-full mt-8 text-white py-3 rounded-full font-medium transition 
                  ${IsLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"
                  }`}
              >
                {IsLoading ? (
                  <div className="flex items-center justify-center">
                    <svg
                      className="animate-spin h-5 w-5 text-white mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    Loading...
                  </div>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default UserAddMaterialRequest;
